<div class="inputGrid w-full">
    <app-input-fulltext
        [form]="form"
        [options]="store.epicrises()"
        (selectedOptionChange)="selectedEpicrisisChange($event)"
    ></app-input-fulltext>
    <app-button
        [disabled]="!isAllowed['folderRecord.create']() || store.isTerminated()"
        (clickEvent)="save()"
        [loading]="store.loadingAny()"
        icon="pi-save"
        label="folder.epicrisis.action.save"
        class="white-space-nowrap"
    ></app-button>
    <app-button
        icon="pi-print"
        severity="secondary"
        label="folder.epicrisis.action.print"
        class="white-space-nowrap"
        (clickEvent)="print()"
    ></app-button>
    <div class="flex-column gap left-container">
        @if (store.folder() && store.serviceId()) {
            <app-service-pattern-wysiwyg
                placeholder="database.persons.epicrisis.text"
                [form]="form"
                id="selectedEpicrisisData"
                editorKey="FolderEpicrisisData"
                [height]="undefined"
                [personId]="store.folder()!.person.id"
                [serviceId]="store.serviceId()"
                [usage]="ServicePatternStructureUsageEnum.EPICRISIS"
                (addedPattern)="formAddText(form, 'selectedEpicrisisData', $event.content)"
                [patternGroups]="wysiwygPatterGroupsMedicalFolder"
            ></app-service-pattern-wysiwyg>
        }
    </div>
    <p-listbox class="fr-2"
        [options]="store.epicrises()"
        [(ngModel)]="selectedEpicrisis"
        (onChange)="listChange($event)"
        [filter]="true"
        [filterPlaceHolder]="'folder.epicrisis.action.history' | translate"
        optionLabel="createdAt"
        dataKey="index"
        styleClass="h-full"
        scrollHeight="calc(100vh - 20rem)"
        [emptyMessage]="'inputs.noResultsFound' | translate"
    >
        <ng-template pTemplate="item" let-item>
            <div (contextmenu)="rightClick(contextMenu, $event, item)" class="w-full">
                <div class="flex-column gap-x-small">
                    <div>{{ item.createdAt }}</div>
                    @if (item.user) {
                        <app-user-chip [user]="item.user"></app-user-chip>
                    }
                </div>
            </div>
        </ng-template>
    </p-listbox>
</div>

<p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
